<template>
  <div
    :class="{
      'pb-column': true,
      ...className,
      flex,
      [`justify-${justify}`]: true,
      [`align-${align}`]: true,
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "PbColumn",
  props: {
    flex: Boolean,
    className: {
      type: Object,
      default: () => {},
    },
    align: {
      type: String, // "center" | "flex-end" | "flex-start",
      default: () => "flex-start",
    },
    justify: {
      type: String, // "center" | "flex-end" | "flex-start" | "space-between" | "space-around",
      default: () => "flex-start",
    },
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/size";

.pb-column {
  @for $i from 1 through 25 {
    &.col#{$i} {
      width: #{100% / 24 * $i};
    }
  }

  &.flex {
    display: flex;

    &.justify {
      &-flex-start {
        justify-content: flex-start;
      }

      &-flex-end {
        justify-content: flex-end;
      }

      &-center {
        justify-content: center;
      }

      &-space-around {
        justify-content: space-around;
      }

      &-space-between {
        justify-content: space-between;
      }
    }

    &.align {
      &-flex-start {
        align-items: flex-start;
      }

      &-flex-end {
        align-items: flex-end;
      }

      &-center {
        align-items: center;
      }
    }
  }
}

@media (max-width: $min_layout) {
  .pb-column {
    width: 100%;
  }
}
</style>
